export default __webpack_public_path__ + "static/media/taskDone.d1b14b62.svg";